import { createContext, useContext } from 'react';
import type {
  CallFailureCategory,
  CallPhase,
  CallTerminalOutcome,
} from './callState';

export type CallStatus =
  | 'idle'
  | 'ringing'
  | 'connecting'
  | 'active'
  | 'reconnecting'
  | 'ending'
  | 'failed';

export interface CallContextValue {
  phase: CallPhase;
  status: CallStatus;
  direction: 'incoming' | 'outgoing' | null;
  roomId: string | null;
  operatorId: number | null;
  error: string | null;
  failureCategory?: CallFailureCategory | null;
  result: CallTerminalOutcome | null;
  resultDirection: 'incoming' | 'outgoing' | null;
  startCall(roomId: string, operatorId: number): Promise<void>;
  acceptCall(): Promise<void>;
  declineCall(): Promise<void>;
  hangUp(): Promise<void>;
  returnToConversation(): void;
  dismissResult(): void;
}

export const CallContext = createContext<CallContextValue | null>(null);

export const useCall = () => {
  const value = useContext(CallContext);
  if (!value) throw new Error('CallProvider is required.');
  return value;
};
